import { IonIcon } from '@ionic/react';
import type { ReactNode } from 'react';
import styles from './InfoCard.module.css';

interface InfoCardProps {
    /** Ionicon name to render inside the accent icon tile. */
    icon?: string;
    /** Alternatively, an SVG source for the icon tile. */
    iconSrc?: string;
    title: string;
    children: ReactNode;
    className?: string;
}

/**
 * A soft, rounded introduction card: an accent icon tile alongside a title and
 * a short explanatory body. Reusable wherever a screen needs a friendly primer
 * above its content (setup flows, empty states, feature intros).
 */
const InfoCard: React.FC<InfoCardProps> = ({ icon, iconSrc, title, children, className }) => {
    return (
        <div className={`${styles.card} ${className ?? ''}`}>
            <div className={styles.iconTile}>
                <IonIcon icon={icon} src={iconSrc} />
            </div>
            <div className={styles.body}>
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.text}>{children}</p>
            </div>
        </div>
    );
};

export default InfoCard;
